// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addStyle[data-v-5a65ac7a] {\n  color: #00A551;\n  cursor: pointer;\n  font-size: 18px;\n}\n.deleteStyle[data-v-5a65ac7a] {\n  color: #F56C6C;\n  cursor: pointer;\n  font-size: 18px;\n}", ""]);
// Exports
module.exports = exports;
